var _style, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520 520",
    style: {
      enableBackground: "new 0 0 520 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#010101;}\n\t.st2{display:none;}\n\t.st3{display:inline;fill:#010101;}\n\t.st4{fill:none;stroke:#E6E7E8;stroke-width:19;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000000;stroke-width:19;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AR"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 260,
    cy: 260,
    r: 250
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M499.6,158.8c-19.7-46.7-52.7-86.4-94.2-114.4C363.9,16.4,313.8,0,260,0c-35.9,0-70.1,7.3-101.2,20.4 c-46.7,19.7-86.4,52.7-114.4,94.2S0,206.2,0,260c0,35.9,7.3,70.1,20.4,101.2c19.7,46.7,52.7,86.4,94.2,114.4S206.2,520,260,520 c35.9,0,70.1-7.3,101.2-20.4c46.7-19.7,86.4-52.7,114.4-94.2S520,313.8,520,260C520,224.1,512.7,189.9,499.6,158.8z M394.2,459 c-38.3,25.9-84.4,41-134.2,41c-33.2,0-64.7-6.7-93.4-18.9c-43.1-18.2-79.7-48.7-105.6-87C35.1,355.9,20,309.7,20,260 c0-33.2,6.7-64.7,18.9-93.4c18.2-43.1,48.7-79.7,87-105.6s84.4-41,134.2-41c33.2,0,64.7,6.7,93.4,18.9 c43.1,18.2,79.7,48.7,105.6,87s41,84.4,41,134.2c0,33.2-6.7,64.7-18.9,93.4C462.9,396.5,432.5,433.1,394.2,459z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M388.2,175.1l-108.4-62.6h0.1c-5.6-3.2-11.8-4.8-18-4.8c-6.2,0-12.4,1.6-18,4.8l0,0L135.6,175l0,0 c-11.1,6.4-18,18.3-18,31.2v125.1c0,12.9,6.9,24.7,18,31.2L243.8,425c5.6,3.2,11.8,4.8,18,4.8c6.2,0,12.4-1.6,18-4.8l108.3-62.5 c11.1-6.4,18-18.3,18-31.2V206.2l0,0C406.2,193.4,399.3,181.5,388.2,175.1z M253.8,129.9c2.5-1.4,5.2-2.1,8-2.1s5.5,0.7,8,2.1 l108.3,62.5c0.2,0.1,0.3,0.2,0.4,0.3l-118.4,65.8L149,190.4L253.8,129.9z M378.2,345.1l-108.3,62.5c-2.5,1.4-5.2,2.1-8,2.1 s-5.5-0.7-8-2.1l-108.3-62.5c-4.9-2.9-8-8.1-8-13.8V206.7l113.6,69.5c2.8,1.7,5.9,2.6,9.1,2.6c2.9,0,5.8-0.7,8.5-2.2l117.5-65.3 v120C386.2,337,383.1,342.3,378.2,345.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "368.3,207.4 395.6,191.9 358.9,170.8 289.6,132.3 260.1,116.6 229.9,133.4 170.2,167.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "228.4,249.7 260.1,268.8 291.5,250.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "170.2,167.6 130,190.6 157.9,207.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M170.2,167.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "260,379.6 260,421.8 219.5,397.9 157.9,361.7 130,345.3 130,311.2 130,234.4 130,190.6 157.9,207.4  228.4,249.7 260.1,268.8 260.1,311.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "260.1,311.2 260.1,268.8 291.5,250.9 368.3,207.4 395.6,191.9 395.6,234.4 395.6,311.2 395.6,345.3  368.3,360.7 299.8,399.3 260,421.8 260,379.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "260.1,116.6 260.1,268.8 395.6,345.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 130,
    y1: 345.3,
    x2: 260.1,
    y2: 268.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "368.3,207.4 395.6,191.9 358.9,170.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "228.4,249.7 260.1,268.8 291.5,250.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "170.2,167.6 130,190.6 157.9,207.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M170.2,167.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "229.9,133.4 260.1,116.6 289.6,132.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "260.1,311.2 260.1,268.8 228.4,249.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "219.5,397.9 260,421.8 260,379.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "130,311.2 130,345.3 157.9,361.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "157.9,207.4 130,190.6 130,234.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "395.6,234.4 395.6,191.9 364.2,209.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "368.3,360.7 395.6,345.3 395.6,311.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "260,379.6 260,421.8 299.8,399.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "260.1,311.2 260.1,268.8 291.5,250.9  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.9,359.9l-4.5-20.9l-26.9-16.3l-4.3,15.1l-12-7.4l23.1-78.6l13.4,7.4l24.3,108.9L204.9,359.9z M186.9,276.2l-9.6,33.7 l19.2,11.5L186.9,276.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Perspective_Text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M342.6,346.5l-10.4-29l-14,7.8v35.4l-11.8,6.9v-94.3l26.9-14.1c14.8-7.7,21.4,2.5,21.4,17.2c0,12.3-4.5,24.4-11.3,32 l11.3,31.1L342.6,346.5z M333.3,273.9l-15.2,8.1v28l15.3-8.4c6.4-3.5,10.1-10.5,10.1-19.2C343.6,275,339.7,270.5,333.3,273.9z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArBtn);
export default __webpack_public_path__ + "static/media/ar-btn.5e7ef83f32beccebdedf7669b78f983a.svg";
export { ForwardRef as ReactComponent };